import getBankAccount from '../../../lib/utils/getBankAccount';
import { getFinalEnrollmentConfiguration } from './configurations';

function hasBankAccount(instruments = []) {
  const BANK_ACCOUNT_TYPES = ['checking_account', 'savings_account'];
  const isBankAccount = instrument => BANK_ACCOUNT_TYPES.includes(instrument.instrument_type);
  return instruments.some(isBankAccount);
}

function hasUsedManualBankAccountLinking(instruments = []) {
  const bankAccount = getBankAccount(instruments);
  return !!bankAccount?.tags?.includes('no-iav') || !!bankAccount?.extra_data?.tags?.includes('no-iav');
}

export default function getEnrollmentConfig(wallet = {}, options = {}) {
  const usedManualBankAccountLinking = hasUsedManualBankAccountLinking(wallet.instruments);
  const linkedBankAccount = hasBankAccount(wallet.instruments);

  const finalOptions = {
    ...options,
    usedManualBankAccountLinking,
    linkedBankAccount,
  };

  return getFinalEnrollmentConfiguration(wallet, finalOptions);
}
